<template>
    <div id="Dataset" class="page" data-page="dataset" :data-taxhavens-selected="selectedTaxHavens">

        <div id="MobileExpandedMap">
            <div class="expanded_closebt" @click="closeExpandedMap()"></div>
            <div class="expanded_instructions">
                Drag to navigate, pinch to zoom in/out
            </div>
            <div class="map_container"></div>
        </div>
        <div id="MobileBottomFixed"></div>

        <appModal ref="appModalRef" :countries="DBCountries"></appModal>
        <appHeader ref="appHeaderRef" bgColor="blue" @headerMenuClicked="menuClicked" page="dataset" :stickyTitle="datasetParams.label"></appHeader>
        <div id="StickyFilters" :class="(stickyFiltersExpanded) ? 'expanded' : ''" @click="showMapModal = false">
            <div class="stickyfilters_bt" @click="toggleMobileFilters()">
                <span v-if="!stickyFiltersExpanded">Change filters</span>
                <span v-else>Close filters</span>
            </div>
            <div class="stickyfilters_content">
                <div class="section_row mapcontrols_toggler app_toggler" :class="(togglerFreezed) ? 'freezed' : ''" :data-selected="(selectedTaxHavens) ? 'on' : 'off'" v-if="hasTaxHavensData">
                    <div class="toggler_wrapper" :data-dataset="datasetID">
                        <div class="toggler_label first" :class="(!selectedTaxHavens) ? 'selected' : ''" @click="toggleTaxHavens()">
                            <span v-if="datasetID == 'global-profit'">Lost</span>
                            <span v-else-if="datasetID == 'offshore-financial'">Held abroad</span>
                        </div>
                        <div class="toggler_toggle" @click="toggleTaxHavens()">
                            <div class="toggle_chip"></div>
                        </div>
                        <div class="toggler_label second" @click="toggleTaxHavens()" :class="(selectedTaxHavens) ? 'selected' : ''">
                            <span v-if="datasetID == 'global-profit'">Won</span>
                            <span v-else-if="datasetID == 'offshore-financial'">Hosted</span>
                        </div>
                    </div>
                </div>

                <div class="section_row row_filters" data-align="left" v-if="datasetIndicators.length > 0">
                    <div class="content_filter">
                        <div class="filter_label">Indicator</div>
                        <v-select class="actionblock_selectbox app_selectbox" v-model="selectedIndicator" :items="datasetIndicators" :return-object="true" label="Choose an indicator" solo>
                            <template slot="selection" scope="data">
                                <div class="item_wrapper">
                                    <div class="item_text">{{ truncateSelectboxItem(data.item.label) }}</div>
                                </div>
                            </template>
                            <template slot="item" slot-scope="data">
                                <div class="item_wrapper" :data-item="data.item.id">
                                    <div class="item_text"><span class="item_icon"></span>{{ data.item.label}}</div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="content_filter" v-if="datasetID == 'global-profit' && !selectedTaxHavens">
                        <div class="filter_label">Counterpart</div>
                        <v-select class="actionblock_selectbox app_selectbox" v-model="selectedCounterpart" :items="datasetCounterparts" :return-object="true" label="Choose a counterpart" solo>
                            <template slot="selection" scope="data">
                                <div class="item_wrapper">
                                    <div class="item_text">{{data.item.label}}</div>
                                </div>
                            </template>
                            <template slot="item" slot-scope="data">
                                <div class="item_wrapper" :data-item="data.item.id">
                                    <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="content_filter">
                        <div class="filter_label">Region</div>
                        <v-select class="actionblock_selectbox app_selectbox" v-model="selectedRegion" :items="DBRegions" :return-object="true" label="Choose a region" solo>
                            <template slot="selection" scope="data">
                                <div class="item_wrapper">
                                    <div class="item_text">{{ truncateSelectboxItem(data.item.label) }}</div>
                                </div>
                            </template>
                            <template slot="item" slot-scope="data">
                                <div class="item_wrapper" :data-item="data.item.id">
                                    <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="content_filter">
                        <div class="filter_label">Income level</div>
                        <v-select class="actionblock_selectbox app_selectbox" v-model="selectedIncomeLevel" :items="DBIncomeLevels" :return-object="true" label="Choose an income level" solo>
                            <template slot="selection" scope="data">
                                <div class="item_wrapper">
                                    <div class="item_text">{{data.item.label}}</div>
                                </div>
                            </template>
                            <template slot="item" slot-scope="data">
                                <div class="item_wrapper" :data-item="data.item.id">
                                    <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>



            </div>
        </div>
        <div class="main">
            <div class="main_loader loader lds-ellipsis" :class="(mainLoaderDisplayed) ? 'displayed' : ''"><div></div><div></div><div></div><div></div></div>
            <div class="main_inner" :class="(mainLoaderDisplayed) ? 'opacified' : ''">
                <section class="main_section" @click="showMapModal = false">
                    <div class="section_content">
                        <h2 class="subtitle_page text_subtitle">Datasets</h2>
                        <h1 class="title_page text_title2" style="margin-top: 10px;" v-if="DBDatasetTexts.title != undefined">
                            {{ DBDatasetTexts.title }}
                        </h1>
                        <button class="app_button2 navigation_bt" @click="openModal('dataset')">Change dataset</button>
                        <p class="text_p" style="margin-top: 14px;" v-if="DBDatasetTexts.description != undefined">
                            {{DBDatasetTexts.description}}
                        </p>
                        <div class="page_infographic" v-if="datasetID != ''" :data-dataset="datasetID" :class="(infographicExpanded) ? 'expanded' : ''">
                            <div class="infographic_image">
                                <img :src="'/images/infographic-'+ datasetID +'.jpg'" class="image_bg" />
                            </div>
                            <div class="more_actionbar">
                                <div class="actionbar_bt" @click="infographicExpanded = !infographicExpanded">{{ infographicExpanded ? 'Close infographic' : 'Expand infographic' }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="main_section section_mapcontrols" @click="showMapModal = false">
                    <div class="section_content">
                        <div class="section_hr" id="HRIndicatorFilters">
                            <div class="hr_text dataset">INDICATOR FILTERS</div>
                        </div>

                        <div class="section_row mapcontrols_toggler app_toggler" :class="(togglerFreezed) ? 'freezed' : ''" :data-selected="(selectedTaxHavens) ? 'on' : 'off'" v-if="hasTaxHavensData">
                            <div class="toggler_wrapper" :data-dataset="datasetID">
                                <div class="toggler_label first" :class="(!selectedTaxHavens) ? 'selected' : ''" @click="toggleTaxHavens()">
                                    <span v-if="datasetID == 'global-profit'">Lost</span>
                                    <span v-else-if="datasetID == 'offshore-financial'">Held abroad</span>
                                </div>
                                <div class="toggler_toggle" @click="toggleTaxHavens()">
                                    <div class="toggle_chip"></div>
                                </div>
                                <div class="toggler_label second" :class="(selectedTaxHavens) ? 'selected' : ''" @click="toggleTaxHavens()">
                                    <span v-if="datasetID == 'global-profit'">Won</span>
                                    <span v-else-if="datasetID == 'offshore-financial'">Hosted</span>
                                </div>
                            </div>
                        </div>

                        <div class="section_row" v-if="DBDatasetTexts.Tax_haven_definition != undefined && DBDatasetTexts.Tax_haven_definition != ''">
                            <span class="text_maxwidthed bolder" v-if="DBDatasetTexts.Tax_haven_definition != undefined">
                                {{ DBDatasetTexts.Tax_haven_definition }}
                            </span>
                        </div>

                        <div id="MobileFilters" class="section_row row_filters" v-if="datasetIndicators.length > 0">
                            <div class="content_filter">
                                <div class="filter_label">Indicator</div>
                                <div class="mobilefilters_bt" @click="forceShowMobileFilters()">Filters</div>
                            </div>
                        </div>

                        <div class="section_row row_filters" id="MapFilters" data-align="left" v-if="datasetIndicators.length > 0">
                            <div class="content_filter">
                                <div class="filter_label">Indicator</div>
                                <v-select class="actionblock_selectbox app_selectbox" v-model="selectedIndicator" :items="datasetIndicators" :return-object="true" label="Choose an indicator" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{ truncateSelectboxItem(data.item.label) }}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="content_filter" v-if="datasetID == 'global-profit'  && !selectedTaxHavens">
                                <div class="filter_label">Counterpart</div>
                                <v-select class="actionblock_selectbox app_selectbox" v-model="selectedCounterpart" :items="datasetCounterparts" :return-object="true" label="Choose a counterpart" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{data.item.label}}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="content_filter">
                                <div class="filter_label">Region</div>
                                <v-select class="actionblock_selectbox app_selectbox" v-model="selectedRegion" :items="DBRegions" :return-object="true" label="Choose a region" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{ truncateSelectboxItem(data.item.label) }}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="content_filter">
                                <div class="filter_label">Income level</div>
                                <v-select class="actionblock_selectbox app_selectbox" v-model="selectedIncomeLevel" :items="DBIncomeLevels" :return-object="true" label="Choose an income level" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{data.item.label}}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>



                    </div>
                </section>

                <section class="main_section" id="Wrapper_map" :data-taxhavens="(selectedTaxHavens) ? 'true': 'false'">

                    <div class="section_content section_map nopad">
                        <div class="map_title" v-if="DBDatasetTexts.Map_title_default != undefined">
                            <span v-if="!selectedTaxHavens">{{ DBDatasetTexts.Map_title_default }}</span>
                            <span v-else>{{ DBDatasetTexts.Map_title_tax_haven }}</span>
                        </div>
                        <div class="mapwrapper_container"  :class="(!mapHasData) ? 'notdisplayed' : ''">
                            <div class="map_legend" v-if="datasetParams.label != undefined">

                                <div class="legend_title">
                                    <div class="title_item" v-if="selectedIndicator.id != 'corp_tax_lost'">
                                        <div class="title_indicator" v-if="selectedIndicator.subtitleLabel != undefined">{{selectedIndicator.subtitleLabel}}</div>
                                        <div class="title_indicator" v-else>{{selectedIndicator.label}}</div>
                                        <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                            <span v-if="!selectedTaxHavens && datasetID =='global-profit'">lost</span>
                                            <span v-else-if="selectedTaxHavens && datasetID =='global-profit'">won</span>
                                            <span v-else-if="!selectedTaxHavens && datasetID =='offshore-financial'">held abroad</span>
                                            <span v-else-if="selectedTaxHavens && datasetID =='offshore-financial'">hosted</span>
                                        </div>
                                    </div>

                                    <div class="title_item" v-else>
                                        <div class="title_indicator">
                                            Corporate tax revenue
                                        </div>
                                        <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                            <span v-if="!selectedTaxHavens && datasetID =='global-profit'">lost</span>
                                            <span v-else-if="selectedTaxHavens && datasetID =='global-profit'">won</span>
                                            <span v-else-if="!selectedTaxHavens && datasetID =='offshore-financial'">held abroad</span>
                                            <span v-else-if="selectedTaxHavens && datasetID =='offshore-financial'">hosted</span>
                                        </div>
                                        <div class="title_indicator">
                                            as a share of corporate tax revenue collected
                                        </div>
                                    </div>

                                    <div class="title_unit" v-if="selectedIndicator.homeUnit != undefined">&nbsp;(in {{selectedIndicator.homeUnit}})</div>
                                    <div class="title_unit" v-else>&nbsp;(in {{selectedIndicator.unit}})</div>

                                    <div class="title_sep" v-if="datasetID == 'global-profit' && !selectedTaxHavens">|</div>
                                    <div class="title_sep" v-if="datasetID == 'global-profit' && !selectedTaxHavens">
                                        Counterpart: {{selectedCounterpart.label}}
                                    </div>
                                    <div class="title_sep">|</div>
                                    <div class="title_param">Region: {{selectedRegion.label}}</div>
                                    <div class="title_sep">|</div>
                                    <div class="title_param">{{selectedIncomeLevel.label}}</div>
                                    <div class="title_sep">|</div>
                                    <div class="title_param">{{mapCurrentYear}}</div>
                                </div>

                            </div>
                            <div class="map_container" :data-hasmodal="(showMapModal) ? 'true': 'false'">
                                <MapModal @closeMapModal="handleCloseMapModal" :countryTooltipData="countryTooltipData" :countriesMapData="countriesMapData" :datasetID="datasetID" :selectedYear="mapCurrentYear" :isShow="showMapModal" :countryDBDataset="mapModalCountryDBDataset" :countryDB="mapModalCountryDB" :DBEffectiveTax="DBEffectiveTax" :DBProfitShiftingTaxHavenTooltipData="DBProfitShiftingTaxHavenTooltipData" :indicatorObj="selectedIndicator" :counterpartObj="selectedCounterpart"></MapModal>

                                <mapChoropleth @countryClicked="handleMapCountryClicked" @currentYear="callbackMapCurrentYear" ref="appMapRef" :mapData="countriesMapData" :indicatorUnit="indicatorUnit" :hasTaxHavensData="hasTaxHavensData" :hasTimeline="mapHasTimeline" :indicatorID="selectedIndicator.id"></mapChoropleth>

                                <div class="map_expand_bt" @click="expandMap()">
                                    <div class="bt">Expand map</div>
                                </div>
                            </div>
                            <div class="content_downloadbar">
                                <div class="downloadbar_wrapper">
                                    <div class="downloadbar_title">Download</div>
                                    <div class="downloadbar_bt" @click="exportXLS('map')">Dataset (.xslx)</div>
                                    <div class="downloadbar_bt" @click="exportGraphic('map', true)">Image (.png)</div>
                                </div>
                            </div>
                            <div class="content_more" v-if="DBDatasetTexts.Map_description != undefined">
                                <div class="more_text">
                                    <div v-if="mapMoreExpanded">
                                        {{ DBDatasetTexts.Map_description }}
                                    </div>
                                    <div v-else>{{ truncate(DBDatasetTexts.Map_description) }}</div>
                                </div>
                                <div class="more_actionbar" v-if="DBDatasetTexts.Map_description.length > mapMoreTextLimit">
                                    <div class="actionbar_bt" @click="mapMoreExpanded = !mapMoreExpanded">{{ mapMoreExpanded ? 'Collapse' : 'Read More' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="chart_nodatablock" :class="(!mapHasData) ? 'displayed' : 'notdisplayed'">
                        </div>
                    </div>
                </section>

                <section id="Wrapper_timeseries" class="main_section section_chart" v-if="datasetID != 'offshore-real-estate' && datasetID != 'offshore-financial'" @click="showMapModal = false">
                    <div class="section_content">
                        <div class="content_title" v-if="DBDatasetTexts.Timeseries_title != undefined">
                            {{ DBDatasetTexts.Timeseries_title }}
                        </div>
                        <div class="section_row">
                            <div class="legend_title">

                                <div class="title_item" v-if="selectedIndicator.id != 'corp_tax_lost'">
                                    <div class="title_indicator" v-if="selectedIndicator.subtitleLabel != undefined">{{selectedIndicator.subtitleLabel}}</div>
                                    <div class="title_indicator" v-else>{{selectedIndicator.label}}</div>

                                    <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                        <span v-if="!selectedTaxHavens && datasetID =='global-profit'">lost</span>
                                        <span v-else-if="selectedTaxHavens && datasetID =='global-profit'">won</span>
                                        <span v-else-if="!selectedTaxHavens && datasetID =='offshore-financial'">held abroad</span>
                                        <span v-else-if="selectedTaxHavens && datasetID =='offshore-financial'">hosted</span>
                                    </div>
                                </div>

                                <div class="title_item" v-else>
                                    <div class="title_indicator">
                                        Corporate tax revenue
                                    </div>
                                    <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                        <span v-if="!selectedTaxHavens && datasetID =='global-profit'">lost</span>
                                        <span v-else-if="selectedTaxHavens && datasetID =='global-profit'">won</span>
                                    </div>
                                    <div class="title_indicator">
                                        as a share of corporate tax revenue collected
                                    </div>
                                </div>

                                <div class="title_unit" v-if="selectedIndicator.homeUnit != undefined">&nbsp;(in {{selectedIndicator.homeUnit}})</div>
                                <div class="title_unit" v-else>&nbsp;(in {{selectedIndicator.unit}})</div>

                                <div class="title_sep" v-if="datasetID == 'global-profit' && !selectedTaxHavens">|</div>
                                <div class="title_sep" v-if="datasetID == 'global-profit' && !selectedTaxHavens">
                                    Counterpart: {{selectedCounterpart.label}}
                                </div>
                                <div class="title_sep">|</div>
                                <div class="title_param">Region: {{selectedRegion.label}}</div>
                                <div class="title_sep">|</div>
                                <div class="title_param">{{selectedIncomeLevel.label}}</div>
                            </div>
                            <highchartsTimeSeries v-if="timeseriesHasData" :timeSeriesData="timeseriesData" :timeSeriesCategories="timeseriesCategories" :indicatorUnit="indicatorUnit" :indicatorLabel="indicatorLabel"></highchartsTimeSeries>
                            <div v-else class="chart_nodatablock">
                            </div>
                        </div>
                        <div class="content_downloadbar">
                            <div class="downloadbar_wrapper">
                                <div class="downloadbar_title">Download</div>
                                <div class="downloadbar_bt" @click="exportXLS('timeseries')">Dataset (.xslx)</div>
                                <div class="downloadbar_bt" @click="exportGraphic('timeseries')">Image (.png)</div>
                            </div>
                        </div>
                        <div class="content_more" v-if="DBDatasetTexts.Timeseries_description != undefined">
                            <div class="more_text">
                                <div v-if="timeseriesMoreExpanded">
                                    {{ DBDatasetTexts.Timeseries_description }}
                                </div>
                                <div v-else>{{ truncate(DBDatasetTexts.Timeseries_description) }}</div>
                            </div>
                            <div class="more_actionbar" v-if="DBDatasetTexts.Timeseries_description.length > mapMoreTextLimit">
                                <div class="actionbar_bt" @click="timeseriesMoreExpanded = !timeseriesMoreExpanded">{{ timeseriesMoreExpanded ? 'Collapse' : 'Read More' }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="Wrapper_area" class="main_section section_chart" v-if="datasetID == 'offshore-financial'" @click="showMapModal = false">
                    <div class="section_content">
                        <div class="content_title" v-if="DBDatasetTexts.Timeseries_title != undefined">{{ DBDatasetTexts.Timeseries_title }}</div>
                        <div class="section_row">
                            <div class="area_legend">
                                <div class="legend_title">

                                    <div class="title_item" v-if="selectedIndicator.id != 'corp_tax_lost'">
                                        <div class="title_indicator" v-if="selectedIndicator.subtitleLabel != undefined">{{selectedIndicator.subtitleLabel}}</div>
                                        <div class="title_indicator" v-else>{{selectedIndicator.label}}</div>
                                        <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                            <span v-if="!selectedTaxHavens && datasetID =='global-profit'">lost</span>
                                            <span v-else-if="selectedTaxHavens && datasetID =='global-profit'">won</span>
                                            <span v-else-if="!selectedTaxHavens && datasetID =='offshore-financial'">held abroad</span>
                                            <span v-else-if="selectedTaxHavens && datasetID =='offshore-financial'">hosted</span>
                                        </div>
                                    </div>

                                    <div class="title_item" v-else>
                                        <div class="title_indicator">
                                            Corporate tax revenue
                                        </div>
                                        <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                            <span v-if="!selectedTaxHavens && datasetID =='global-profit'">lost</span>
                                            <span v-else-if="selectedTaxHavens && datasetID =='global-profit'">won</span>
                                        </div>
                                        <div class="title_indicator">
                                            as a share of corporate tax revenue collected
                                        </div>
                                    </div>


                                    <div class="title_unit" v-if="selectedIndicator.homeUnit != undefined">&nbsp;(in {{selectedIndicator.homeUnit}})</div>
                                    <div class="title_unit" v-else>&nbsp;(in {{selectedIndicator.unit}})</div>

                                    <div class="title_sep">|</div>
                                    <div class="title_param">Region: {{selectedRegion.label}}</div>
                                    <div class="title_sep">|</div>
                                    <div class="title_param">{{selectedIncomeLevel.label}}</div>
                                </div>
                            </div>
                            <highchartsAreaChart v-if="areaHasData" :areaChartData="areaChartData" :areaChartCategories="areaChartCategories" :indicatorUnit="indicatorUnit" :indicatorLabel="indicatorLabel"></highchartsAreaChart>
                            <div v-else class="chart_nodatablock">
                            </div>
                        </div>
                        <div class="content_downloadbar">
                            <div class="downloadbar_wrapper">
                                <div class="downloadbar_title">Download</div>
                                <div class="downloadbar_bt" @click="exportXLS('area')">Dataset (.xslx)</div>
                                <div class="downloadbar_bt" @click="exportGraphic('area')">Image (.png)</div>
                            </div>
                        </div>
                        <div class="content_more" v-if="DBDatasetTexts.Timeseries_description != undefined">
                            <div class="more_text">
                                <div v-if="timeseriesMoreExpanded">
                                    {{ DBDatasetTexts.Timeseries_description }}
                                </div>
                                <div v-else>{{ truncate(DBDatasetTexts.Timeseries_description) }}</div>
                            </div>
                            <div class="more_actionbar" v-if="DBDatasetTexts.Timeseries_description.length > mapMoreTextLimit">
                                <div class="actionbar_bt" @click="timeseriesMoreExpanded = !timeseriesMoreExpanded">{{ timeseriesMoreExpanded ? 'Collapse' : 'Read More' }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="main_section section_chart" @click="showMapModal = false">
                    <div class="section_content">
                        <div class="content_title" v-if="DBDatasetTexts.Ranking_title != undefined">
                            <span v-if="datasetID == 'offshore-financial' && !selectedTaxHavens">
                                Which countries own most offshore financial wealth?
                            </span>
                            <span v-else>{{ DBDatasetTexts.Ranking_title }}</span>
                        </div>
                        <div class="legend_title" style="margin-top: 10px;">

                            <div class="title_item" v-if="selectedIndicator.id != 'corp_tax_lost'">
                                <div class="title_indicator" v-if="selectedIndicator.subtitleLabel != undefined">{{selectedIndicator.subtitleLabel}}</div>
                                <div class="title_indicator" v-else>{{selectedIndicator.label}}</div>
                                
                                <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                    <span v-if="!selectedTaxHavens && datasetID =='global-profit'">lost</span>
                                    <span v-else-if="selectedTaxHavens && datasetID =='global-profit'">won</span>
                                    <span v-else-if="!selectedTaxHavens && datasetID =='offshore-financial'">held abroad</span>
                                    <span v-else-if="selectedTaxHavens && datasetID =='offshore-financial'">hosted</span>
                                </div>
                            </div>

                            <div class="title_item" v-else>
                                <div class="title_indicator">
                                    Corporate tax revenue
                                </div>
                                <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                    <span v-if="!selectedTaxHavens && datasetID =='global-profit'">lost</span>
                                    <span v-else-if="selectedTaxHavens && datasetID =='global-profit'">won</span>
                                </div>
                                <div class="title_indicator">
                                    as a share of corporate tax revenue collected
                                </div>
                            </div>


                            <div class="title_unit" v-if="selectedIndicator.homeUnit != undefined">&nbsp;(in {{selectedIndicator.homeUnit}})</div>
                            <div class="title_unit" v-else>&nbsp;(in {{selectedIndicator.unit}})</div>

                            <div class="title_sep" v-if="datasetID == 'global-profit' && !selectedTaxHavens">|</div>
                            <div class="title_sep" v-if="datasetID == 'global-profit' && !selectedTaxHavens">
                                Counterpart: {{selectedCounterpart.label}}
                            </div>
                            <div class="title_sep">|</div>
                            <div class="title_param">Region: {{selectedRegion.label}}</div>
                            <div class="title_sep">|</div>
                            <div class="title_param">{{selectedIncomeLevel.label}}</div>
                        </div>
                        <div class="content_col col_ranking">
                            <div class="ranking_container" :class="(!rankingHasData) ? 'notdisplayed' : ''">
                                <rankingGraph :rankingData="countriesRankingData" :indicatorUnit="indicatorUnit" :hasTimeline="rankingHasTimeline" :sortingOrder="rankingSortingOrder"></rankingGraph>
                            </div>
                            <div class="chart_nodatablock" :class="(!rankingHasData) ? 'displayed' : 'notdisplayed'">
                            </div>
                        </div>
                        <div class="content_col col_ranking_text">
                            <p class="text_p" v-if="DBDatasetTexts.Ranking_description != undefined">
                                {{ DBDatasetTexts.Ranking_description }}
                            </p>
                        </div>
                    </div>
                </section>

                <section id="Wrapper_barchart" class="main_section section_bubbles" v-if="datasetID == 'offshore-real-estate'" @click="showMapModal = false">
                    <div class="section_content">
                        <div class="content_title" v-if="DBDatasetTexts.City_title != undefined">
                            {{ DBDatasetTexts.City_title }}
                        </div>
                        <div class="bubble_container" :class="(!bubbleHasData) ? 'notdisplayed' : ''">
                            
                            <div class="content_row" v-if="selectedIndicator.id != 'pctGDP'">
                                <bubblesGraph :bubblesData="sortedCitiesData" indicatorUnit=" B$"></bubblesGraph>
                            </div>

                            <div class="content_row" v-else>
                                <p class="text_p">Switch the indicator to find additional data on offshore real estate at the city level</p>
                            </div>
                            
                            <!--
                            <div class="content_row row_barchart" id="Wrapper_barchart">
                                <div class="legend_title">
                                    <div class="title_indicator">{{selectedIndicator.label}}</div>
                                    <div class="title_unit">&nbsp;(in {{selectedIndicator.unit}})</div>
                                    <div class="title_sep">|</div>
                                    <div class="title_param">{{selectedRegion.label}}</div>
                                    <div class="title_sep">|</div>
                                    <div class="title_param">{{selectedIncomeLevel.label}}</div>
                                </div>
                                <highchartsBarChart :barChartData="realEstate2Series" :barChartCategories="realEstate2Categories" indicatorUnit="%" :indicatorLabel="indicatorLabel"></highchartsBarChart>
                            </div>
                            <div class="content_downloadbar">
                                <div class="downloadbar_wrapper">
                                    <div class="downloadbar_title">Download</div>
                                    <div class="downloadbar_bt" @click="exportXLS('barchart')">Dataset (.xslx)</div>
                                    <div class="downloadbar_bt" @click="exportGraphic('barchart')">Image (.png)</div>
                                </div>
                            </div>
                            <div class="content_more" v-if="DBDatasetTexts.City_description != undefined">
                                <div class="more_text">
                                    <div v-if="bubblesBarchartMoreExpanded">
                                        {{ DBDatasetTexts.City_description }}
                                    </div>
                                    <div v-else>{{ truncate(DBDatasetTexts.City_description) }}</div>
                                </div>
                                <div class="more_actionbar" v-if="DBDatasetTexts.City_description.length > mapMoreTextLimit">
                                    <div class="actionbar_bt" @click="bubblesBarchartMoreExpanded = !bubblesBarchartMoreExpanded">{{ bubblesBarchartMoreExpanded ? 'Collapse' : 'Read More' }}</div>
                                </div>
                            </div>
                            -->
                        </div>
                        <div class="chart_nodatablock" :class="(!bubbleHasData) ? 'displayed' : 'notdisplayed'">
                        </div>
                    </div>
                </section>
                
            </div> 
        </div>
        <appFooter @headerMenuClicked="menuClicked"></appFooter>
        <cookiesConsent></cookiesConsent>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import Vuetify from 'vuetify'
    Vue.use(Vuetify)
    import 'vuetify/dist/vuetify.min.css'

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'
    import mapChoropleth from '~/components/mapChoropleth.vue'
    import highchartsTimeSeries from '~/components/highchartsTimeSeries.vue'
    import rankingGraph from '~/components/rankingGraph.vue'
    import highchartsAreaChart from '~/components/highchartsAreaChart'
    import highchartsBarChart from '~/components/highchartsBarChart'
    import bubblesGraph from '~/components/bubblesGraph.vue'
    import cookiesConsent from '~/components/cookiesConsent.vue'
    import MapModal from '~/components/MapModal.vue'

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal,
            "mapChoropleth": mapChoropleth,
            "rankingGraph": rankingGraph,
            "bubblesGraph": bubblesGraph,
            "highchartsAreaChart": highchartsAreaChart,
            "highchartsTimeSeries": highchartsTimeSeries,
            "highchartsBarChart": highchartsBarChart,
            "cookiesConsent": cookiesConsent,
            "MapModal": MapModal
        },

        data: function () {
            return {
                isDataLoaded: false,

                datasetID: "",
                datasetParams: {
                    label: ""
                },
                DBDatasets: {
                    "effective-tax": {},
                    "global-profit": {},
                    "offshore-financial": {},
                    "offshore-real-estate": {},
                },
                DBDatasetTexts: {},
                datasetIndicators: [],
                selectedIndicator: {},
                datasetCounterparts: [],
                selectedCounterpart: {},
                indicatorUnit: "",

                DBCountries:[],
                DBCountriesObj: {},
                DBCountriesDenominator: [],

                DBRegions: [],
                DBRealEstate2: [],
                selectedRegion: {},
                DBIncomeLevels: [],
                selectedIncomeLevel: {},

                filteredCountries: [],

                mapIndicators:[
                    { indicatorID:"Profit_shifting", label: "Global profit shifting by multinational enterprises" },
                    { indicatorID:"Effective_tax_rate", label: "Effective tax rates on capital and labor" },
                    { indicatorID:"Offshore_FW", label: "Offshore financial wealth" },
                    { indicatorID:"Offshore_RE", label: "Offshore real estate wealth" },
                ],
                mapData: [],
                selectedTaxHavens: false,
                hasTaxHavensData: false,
                taxHavenCountryParam: "",
                taxHavensCountries: [],
                mapMoreTextLimit: 300,
                mapMoreExpanded: false,
                mapHasTimeline: true,

                timeseriesCategories: [],
                timeseriesData: [],
                timeseriesHasData: true,
                timeseriesMoreExpanded: false,

                mapHasData: true,
                rankingHasData: true,
                areaHasData: true,
                indicatorUnit: "",
                indicatorLabel: "",
                countriesRankingData: [],
                countriesMapData: { type: "map", countries: []},
                sortedCitiesData: [],
                areaChartData: [],
                areaChartCategories: [],
                realEstate2Series: [],
                realEstate2Categories: [],
                rankingHasTimeline: true,
                bubblesBarchartMoreExpanded: false,
                bubbleHasData: true,
                mainLoaderDisplayed: true,

                stickyFiltersExpanded: true,
                togglerFreezed: false,
                selectboxItemLimit: 22,
                forceShowMobile: false,
                infographicExpanded: false,

                mapCurrentYear: "",
                rankingSortingOrder: "desc",

                loadingMethod: "csv",

                showMapModal: false,
                countryTooltipData: {
                    id: "",
                    value: ""
                },
                mapModalCountryDBDataset:{},
                mapModalCountryDB: {},
                DBEffectiveTax: {},
                DBProfitShiftingTaxHavenTooltipData: {},

                allowTouchExpandMapMobile: true,
                panMapinstance: "",
                touchDragging: false,
                touchTimeout: "",
                zoomTimeout: ""
            }
        },

        created: function () {

        },

        mounted: function () {
            var self = this;

            //if(location.host == "staging-eu-tax-observatory.wedodata.dev") this.loadingMethod = "gsheet";

            this.datasetID = this.$route.params.datasetID;
            this.datasetParams = UTILS.DATASETS_PARAMS[this.datasetID];

            this.datasetIndicators = this.datasetParams.indicators;
            this.selectedIndicator = this.datasetIndicators[0];

            if(this.datasetID == "global-profit"){
                this.datasetCounterparts = this.datasetParams.counterparts;
                this.selectedCounterpart = this.datasetCounterparts[0];
                this.hasTaxHavensData = true;
                this.taxHavenCountryParam = "Tax_haven_profit_shifting";
            } else if(this.datasetID == "offshore-financial"){
                this.hasTaxHavensData = true;
                this.taxHavenCountryParam = "Tax_haven_offshore_financial_wealth";
            } else if(this.datasetID == "offshore-real-estate"){
                this.mapHasTimeline = false;
                this.rankingHasTimeline = false;
                this.datasetIndicators = _.filter(this.datasetParams.indicators, function (o){
                    return o.isOnlyCountry == undefined || !o.isOnlyCountry
                })
            }

            this.DBRegions = JSON.parse(JSON.stringify(UTILS.DB_REGIONS));
            this.selectedRegion = this.DBRegions[0];
            this.DBIncomeLevels = JSON.parse(JSON.stringify(UTILS.DB_INCOME_LEVELS));
            this.selectedIncomeLevel = this.DBIncomeLevels[0];

            document.querySelector("body").setAttribute("data-fixed", "true");

            //this.loadCSVData();
            this.handleScroll();

            if(this.loadingMethod == "csv"){
                this.loadTextsCSVData();
            } else {
                this.loadTextsSpreadsheetData();
            }
            
        },

        methods: {
            handleScroll: function (){
                var self = this;
                window.onscroll = function() {
                    var app = document.getElementById('app');
                    var specificElement = document.getElementById('HRIndicatorFilters');
                    if(specificElement != undefined){
                        var triggerPoint = specificElement.offsetTop + specificElement.offsetHeight - 60;

                        if(self.forceShowMobile){
                            app.classList.add("sticky");
                        } else {
                            if (window.pageYOffset > triggerPoint) {
                                app.classList.add("sticky");
                            } else {
                                app.classList.remove("sticky");
                            }
                        }
                    }
                    
                };
            },

            loadTextsCSVData: function (){
                var self = this;

                UTILS.loadTextsCSVData().then(function (callbackDBTexts){
                    self.DBDatasetTexts = _.find(callbackDBTexts, function (o){
                        return o.dataset_id == self.datasetID;
                    });
                    self.loadCSVData();
                }).catch(err => {
                    console.log(err);
                  });
            },

            loadTextsSpreadsheetData: function () {
                var self = this;

                UTILS.loadTextsSpreadsheetData().then(function (callbackDBTexts){
                    self.DBDatasetTexts = _.find(callbackDBTexts, function (o){
                        return o.dataset_id == self.datasetID;
                    });
                    self.loadSpreadsheetData();
                }).catch(err => {
                    console.log(err);
                  });
            },

            loadCSVData: function (){
                var self = this;

                console.log("loadCSVData");

                this.mainLoaderDisplayed = false;
                document.querySelector("body").setAttribute("data-fixed", "false");

                UTILS.loadSingleDatasetsCSVData(this.datasetID).then(function (callbackDBDatasets){
                    self.DBDatasets = JSON.parse(JSON.stringify(callbackDBDatasets));
                    console.log("loadSingleDatasetsCSVData", self.DBDatasets);
                    if(self.datasetID == "offshore-real-estate"){
                        UTILS.loadRealEstate2CSVData().then(function (callbackRE2){
                            self.DBRealEstate2 = JSON.parse(JSON.stringify(callbackRE2));
                            self.loadCountriesCSVMetadata();
                        })
                    } else {
                        if(self.datasetID == "effective-tax"){
                            self.loadEffectiveTaxModalData();
                        } else if(self.datasetID == "global-profit"){
                            self.loadProfitShiftingModalData();
                        } else {
                            self.loadCountriesCSVMetadata();
                        }
                        
                    }
                });
            },

            loadProfitShiftingModalData: function (){
                var self = this;
                console.log("loadProfitShiftingModalData");
                UTILS.loadProfitShiftingModalCSVData().then(callbackDBDatasets => {
                    console.log("loadProfitShiftingModalData", callbackDBDatasets);
                    self.DBProfitShiftingTaxHavenTooltipData = JSON.parse(JSON.stringify(callbackDBDatasets));
                    console.log("DBProfitShiftingTaxHavenTooltipData", self.DBProfitShiftingTaxHavenTooltipData);
                    self.loadCountriesCSVMetadata();
                  }).catch(err => {
                    console.log(err);
                  });
            },

            loadEffectiveTaxModalData: function (){
                var self = this;
                UTILS.loadEffectiveTaxModalCSVData().then(callbackDBDatasets => {
                    self.DBEffectiveTax = JSON.parse(JSON.stringify(callbackDBDatasets));
                    console.log("DBEffectiveTax", self.DBEffectiveTax);
                    self.loadCountriesCSVMetadata();
                  }).catch(err => {
                    console.log(err);
                  });
            },

            loadSpreadsheetData: function (){
                var self = this;

                this.mainLoaderDisplayed = false;
                document.querySelector("body").setAttribute("data-fixed", "false");


                UTILS.loadSingleDatasetsSpreadsheetData(this.datasetID).then(function (callbackDBDatasets){
                    self.DBDatasets = JSON.parse(JSON.stringify(callbackDBDatasets));
                    //self.loadCountriesSpreadsheets();

                    if(self.datasetID == "offshore-real-estate"){
                        UTILS.loadRealEstate2SpreadsheetData().then(function (callbackRE2){
                            self.DBRealEstate2 = JSON.parse(JSON.stringify(callbackRE2));
                            self.loadCountriesMetadata();
                        })
                    } else {
                        self.loadCountriesMetadata();
                    }
                });
            },

            loadCountriesMetadata: function (){
                var self = this;

                UTILS.loadCountriesSpreadsheetData(true).then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                    self.DBCountriesDenominator = JSON.parse(JSON.stringify(callbackDBCountries.dbCountriesDenominator));
                    self.DBCountriesObj = JSON.parse(JSON.stringify(UTILS.DB_COUNTRIES_OBJ));
                    self.populateData();
                }).catch(err => {
                console.log(err);
              });
            },

            loadCountriesCSVMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData(true).then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                    self.DBCountriesDenominator = JSON.parse(JSON.stringify(callbackDBCountries.dbCountriesDenominator));
                    self.DBCountriesObj = JSON.parse(JSON.stringify(UTILS.DB_COUNTRIES_OBJ));
                    self.populateData();
                }).catch(err => {
                console.log(err);
              });
            },

            populateData: function (){
                var self = this;

                this.updatePage();
                this.isDataLoaded = true;
            },

            updatePage: function (){
                var self = this;

                var filteredCountriesIndicatorData = [];
                var tmpTaxHavenCountries = []

                console.log("DBDatasets", this.DBDatasets);

                var countries = _.keys(this.DBDatasets[this.datasetID]);
                console.log("countries", JSON.stringify(countries));

                _.each(this.DBDatasets[this.datasetID], function (countryObj, countryCode){
                    var toAppend = true;
                    if(countryCode == "WRLD" || self.DBCountriesObj[countryCode] == undefined) return;

                    var countryParams = self.DBCountriesObj[countryCode];
                    if(self.selectedIncomeLevel.id != UTILS.ALL_INCOME_LEVEL_ID){
                        if(countryParams.incomelevelname != self.selectedIncomeLevel.id) toAppend = false;
                    }

                    if(self.selectedRegion.id != UTILS.ALL_REGION_ID){
                        if(countryParams.regionname != self.selectedRegion.id) toAppend = false;
                    }

                    if(!self.selectedTaxHavens){
                        if(self.DBCountriesObj[countryCode][self.taxHavenCountryParam] == "yes"){
                            if(toAppend) tmpTaxHavenCountries.push(self.DBCountriesObj[countryCode]);
                            toAppend = false;
                        }
                    } else{
                        if(self.DBCountriesObj[countryCode][self.taxHavenCountryParam] != "yes"){
                            toAppend = false;
                        } else {
                            if(toAppend) tmpTaxHavenCountries.push(self.DBCountriesObj[countryCode]);
                        }
                    }

                    if(toAppend){
                        if(self.selectedIndicator.computed){
                            var numeratorID = self.selectedIndicator.computationParams.numerator;
                            if(self.selectedTaxHavens) numeratorID = self.selectedIndicator.computationParams.numeratorTaxHaven;

                            if(countryObj.indicators[numeratorID] != undefined){
                                var indicatorYearsObj = JSON.parse(JSON.stringify(countryObj.indicators[numeratorID]));

                                _.each(indicatorYearsObj.years, function (yearObj, yearID){
                                    var denominatorValue = 1;
                                    if(self.selectedIndicator.computationParams.denominator == "custom"){
                                        if(self.selectedIndicator.id == "pctGlobalEstate"){
                                            denominatorValue = UTILS.GLOBAL_REAL_ESTATE;
                                        } else if(self.selectedIndicator.id == "pctCityEstate") {

                                        }
                                    } else {
                                        /*
                                        var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                            return String(o.year) == String(yearID) && o.iso3 == countryCode;
                                        })
                                        */

                                        if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryCode] != undefined && UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryCode].years[yearID] != undefined){
                                            denominatorValue = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryCode].years[yearID][self.selectedIndicator.computationParams.denominator];
                                        }                                        
                                    }
                                    

                                    if(self.datasetID == "offshore-real-estate"){
                                        _.each(yearObj, function (cityObj, cityID){
                                            var cityVal = cityObj.value;
                                            cityObj.value = (cityVal / denominatorValue) * 100;
                                            cityObj.nonDenValue = cityVal;
                                        })
                                    } else if(self.datasetID == "offshore-financial"){
                                        if(denominatorValue == "") yearObj.value = "nodata";
                                        else yearObj.value = (yearObj.value / denominatorValue) * 100;
                                    }
                                })
                                
                                var yearsValues = _.map(indicatorYearsObj.years, function (yObj){
                                    return yObj.value;
                                })

                                if(_.uniq(yearsValues) == "nodata"){

                                } else {
                                    filteredCountriesIndicatorData.push({
                                        countryCode: countryCode,
                                        indicatorObj: indicatorYearsObj,
                                        allIndicators: countryObj.indicators
                                    })
                                }
                            }
                        } else {
                            var indicatorID = self.selectedIndicator.id;
                            if(self.selectedTaxHavens) indicatorID = self.selectedIndicator.taxHavenID;

                            if(countryObj.indicators[indicatorID] != undefined){
                                var yearsValues = _.map(countryObj.indicators[indicatorID].years, function (yObj){
                                    return yObj.value;
                                })

                                if(_.uniq(yearsValues) == "nodata"){

                                } else {
                                    filteredCountriesIndicatorData.push({
                                        countryCode: countryCode,
                                        indicatorObj: countryObj.indicators[indicatorID],
                                        allIndicators: countryObj.indicators
                                    })
                                }
                                
                            }
                        }
                    }
                });
                
                console.log("filteredCountriesIndicatorData", filteredCountriesIndicatorData);

                this.taxHavensCountries = JSON.parse(JSON.stringify(tmpTaxHavenCountries));

                this.filteredCountries = JSON.parse(JSON.stringify(filteredCountriesIndicatorData));

                this.indicatorUnit = this.selectedIndicator.smallUnit;
                this.indicatorLabel = this.selectedIndicator.label;

                //GlobalProfit
                if(this.datasetID == "global-profit"){
                    this.updateGlobalProfitTimeseries();
                } else if(this.datasetID == "offshore-real-estate"){
                    this.updateOffshoreCityBubbles();
                    this.updateRealEstate2Barchart();
                } else if(this.datasetID == "offshore-financial"){
                    this.updateOffshoreFinancialAreaChart();
                } else if(this.datasetID == "effective-tax"){
                    this.rankingSortingOrder = "asc";
                    this.updateEffectiveTaxTimeserie();
                }

                this.updateCountriesRankingAndMap();
            },

            updateGlobalProfitTimeseries: function (){
                var self = this;

                var yearlyObj = {};


                var specificFilteredCountries = JSON.parse(JSON.stringify(this.filteredCountries));
                if(this.selectedIncomeLevel.id == "All income levels" && this.selectedRegion.id == "World" && !this.selectedTaxHavens){
                    var specificROWObj = {
                        countryCode: "ROW",
                        indicatorObj: JSON.parse(JSON.stringify(this.DBDatasets[this.datasetID]["ROW"].indicators[this.selectedIndicator.id]))
                    }
                    specificFilteredCountries.push(specificROWObj);
                }

                if(this.selectedIndicator.id == "corp_tax_lost"){

                    _.each(specificFilteredCountries, function (countryObj){
                        var indicatorID = "tax_lost";
                        if(self.selectedTaxHavens) indicatorID = "tax_won";

                        var indicatorObj = undefined;
                        if(self.DBDatasets[self.datasetID][countryObj.countryCode].indicators[indicatorID] !== undefined){
                            indicatorObj = self.DBDatasets[self.datasetID][countryObj.countryCode].indicators[indicatorID];
                        }
 
                        if(indicatorObj != undefined && indicatorObj.counterparts[self.selectedCounterpart.id] !== undefined){
                            _.each(indicatorObj.counterparts[self.selectedCounterpart.id].years, function (yearObj, yearID){
                                if(yearlyObj[yearID] == undefined){
                                    yearlyObj[yearID] = {
                                        yearID: yearID,
                                        sum: 0,
                                        inc: 0,
                                        gdpTotal: 0,
                                        citRevenueTotal: 0,
                                        weightedAvgSum: 0
                                    };
                                }

                                if(yearObj.value != 'nodata' && yearObj.value != null){
                                    yearlyObj[yearID].sum += yearObj.value;
                                    yearlyObj[yearID].inc += 1;
                                    //yearlyObj[yearID].corpIncTotal += 1;
                                }
                                
                                if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode] != undefined){
                                    var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode].years[yearID];
                                    if(denominatorObj != undefined && denominatorObj.cit_revenue_USD_billion != 'nodata'){
                                        yearlyObj[yearID].citRevenueTotal += denominatorObj.cit_revenue_USD_billion;
                                    }
                                }
                                
                                
                            })
                        }
                    });
                } else {
                    _.each(specificFilteredCountries, function (countryObj){
                        if(countryObj.indicatorObj.counterparts[self.selectedCounterpart.id] !== undefined){
                            _.each(countryObj.indicatorObj.counterparts[self.selectedCounterpart.id].years, function (yearObj, yearID){
                                if(yearlyObj[yearID] == undefined){
                                    yearlyObj[yearID] = {
                                        yearID: yearID,
                                        sum: 0,
                                        inc: 0,
                                        gdpTotal: 0,
                                        citRevenueTotal: 0,
                                        weightedAvgSum: 0
                                    };
                                }

                                if(yearObj.value != 'nodata' && yearObj.value != null){
                                    yearlyObj[yearID].sum += yearObj.value;
                                    yearlyObj[yearID].inc += 1;
                                    //yearlyObj[yearID].corpIncTotal += 1;
                                }
                                
                                /*
                                var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                    return String(o.year) == String(yearID) && o.iso3 == countryObj.countryCode;
                                })
                                */
                                if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode] != undefined){
                                    var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode].years[yearID];
                                    if(denominatorObj != undefined && denominatorObj.cit_revenue_USD_billion != 'nodata'){
                                        yearlyObj[yearID].citRevenueTotal += denominatorObj.cit_revenue_USD_billion;
                                    }
                                }
                                
                                
                            })
                        }
                    });
                }
                

                if(this.selectedIndicator.id == "corp_tax_lost"){
                    _.each(specificFilteredCountries, function (countryObj){
                        if(countryObj.indicatorObj.counterparts[self.selectedCounterpart.id] !== undefined){
                            _.each(countryObj.indicatorObj.counterparts[self.selectedCounterpart.id].years, function (yearObj, yearID){
                                if(yearObj.value != null && yearObj.value != 'nodata'){
                                    /*
                                    var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                        return String(o.year) == String(yearID) && o.iso3 == countryObj.countryCode;
                                    })
                                    */
                                    yearlyObj[yearID].weightedAvgSum = (yearlyObj[yearID].sum / yearlyObj[yearID].citRevenueTotal) * 100;

                                    /*
                                    if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode] != undefined){
                                        var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode].years[yearID];
                                        if(denominatorObj.gdp_USD_billion != 'nodata'){
                                            yearlyObj[yearID].weightedAvgSum += (yearObj.value * (denominatorObj.gdp_USD_billion / yearlyObj[yearID].gdpTotal));
                                        }
                                    }
                                    */
                                }
                            })
                        }
                    });
                }

                this.timeseriesCategories = _.keys(yearlyObj);

                var timeseriesColor = "#164193";
                if(this.selectedTaxHavens) timeseriesColor = "#F18221";

                var seriesData =  _.map(yearlyObj, function (o){ return o.sum; });
                if(this.selectedIndicator.id == "corp_tax_lost") seriesData =  _.map(yearlyObj, function (o){ return o.weightedAvgSum; });

                if(seriesData.length > 0){
                    this.timeseriesHasData = true;
                    this.timeseriesData = [{
                        name: "Countries",
                        data: seriesData,
                        color: timeseriesColor
                    }];
                } else {
                    this.timeseriesHasData = false;
                }
                
            },

            updateEffectiveTaxTimeserie: function () {
                var self = this;

                var yearlyObj = {};

                _.each(this.filteredCountries, function (countryObj){
                    _.each(countryObj.indicatorObj.years, function (yearObj, yearID){
                        if(yearlyObj[yearID] == undefined){
                            yearlyObj[yearID] = {
                                yearID: yearID,
                                sum: 0,
                                inc: 0,
                                ndpTotal: 0,
                                incNDP: 0,
                                weightedAvgSum: 0
                            };
                        }

                        if(yearObj.value != null && yearObj.value != 'nodata'){
                            /*
                            var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                return String(o.year) == String(yearID) && o.iso3 == countryObj.countryCode;
                            })
                            */
                            if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode] != undefined){
                                var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode].years[yearID];
                                yearlyObj[yearID].sum += yearObj.value;
                                yearlyObj[yearID].inc += 1;
                                if(denominatorObj.ndp_USD_billion != 'nodata'){
                                    yearlyObj[yearID].ndpTotal += denominatorObj.ndp_USD_billion;
                                    yearlyObj[yearID].incNDP += 1;
                                }
                            }
                        }
                    })
                });

                console.log("updateEffectiveTaxTimeserie", yearlyObj);

                _.each(this.filteredCountries, function (countryObj){
                    _.each(countryObj.indicatorObj.years, function (yearObj, yearID){
                        if(yearObj.value != null && yearObj.value != 'nodata'){
                            /*
                            var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                return String(o.year) == String(yearID) && o.iso3 == countryObj.countryCode;
                            })
                            */
                            if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode] != undefined){
                                var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode].years[yearID];
                                if(denominatorObj.ndp_USD_billion != 'nodata'){
                                    yearlyObj[yearID].weightedAvgSum += (yearObj.value * (denominatorObj.ndp_USD_billion / yearlyObj[yearID].ndpTotal));
                                }
                            }
                        }
                    })
                });

                console.log("updateEffectiveTaxTimeserie 2", yearlyObj);

                var yearlyObjWithData = _.filter(yearlyObj, function (o, yearID){
                    return o.inc > 0;
                })

                if(this.selectedIncomeLevel.id == "Upper middle income" && (this.selectedRegion.id == "Europe and Central Asia" || this.selectedRegion.id == "East Asia and Pacific" )){
                    yearlyObjWithData = _.filter(yearlyObj, function (o, yearID){
                        return o.inc > 0 && yearID >= 1994;
                    })
                }

                console.log("yearlyObjWithData", yearlyObjWithData);

                if(yearlyObjWithData.length > 0) {
                    this.timeseriesCategories = _.map(yearlyObjWithData, function (o){ return o.yearID});
                    this.timeseriesData = [{
                        name: "Countries",
                        data: _.map(yearlyObjWithData, function (o){ return o.weightedAvgSum; }),
                        color: "#164193"
                    }];
                    this.timeseriesHasData = true;
                } else {
                    this.timeseriesHasData = false;
                }
            },

            updateOffshoreCityBubbles: function (){
                var self = this;

                var citiesObj = {};

                if(this.filteredCountries.length == 0){
                    this.bubbleHasData = false;
                    return;
                }

                this.bubbleHasData = true;

                var availableYears = _.keys(this.filteredCountries[0].indicatorObj.years);
                var lastYear = availableYears[availableYears.length - 1];
                var denominatorTotalVal = 0;

                _.each(this.filteredCountries, function (countryObj){
                    var yearlyObj = countryObj.indicatorObj.years[lastYear];
                    
                    /*
                    if(self.selectedIndicator.id == "pctGDP"){
                        var denominatorValue = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryObj.countryCode].years[lastYear][self.selectedIndicator.computationParams.denominator];
                        if(denominatorValue != "nodata") denominatorTotalVal += denominatorValue;
                    }
                    */

                    _.each(yearlyObj, function (cityObj, cityID){
                        if(cityID != "Total"){
                            if(citiesObj[cityID] == undefined){
                                citiesObj[cityID] = {
                                    cityID: cityID,
                                    total: 0
                                }
                            }
                            if(self.selectedIndicator.id == "pctGDP"){
                                if(cityObj.nonDenValue !== '' && cityObj.nonDenValue != 'nodata') citiesObj[cityID].total += cityObj.nonDenValue;
                            } else{
                                if(cityObj.value !== '' && cityObj.value != 'nodata') citiesObj[cityID].total += cityObj.value;
                            }
                        }
                        
                    })
                })

                /*
                if(self.selectedIndicator.id == "pctGDP"){
                    _.each(citiesObj, function (o){
                        o.total = (o.total / denominatorTotalVal) * 100;
                    })
                }
                */
                var sortedCities = _.sortBy(citiesObj, function (o){
                    return -o.total;
                });

                this.sortedCitiesData = JSON.parse(JSON.stringify(sortedCities));
            },

            updateOffshoreFinancialAreaChart: function () {
                var self = this;

                if(this.filteredCountries.length == 0){
                    this.areaHasData = false;
                    return
                }

                this.areaHasData = true;
                this.areaChartCategories = _.keys(this.filteredCountries[0].allIndicators.total.years);

                var yearsObjTotal = {
                    "swiss": { years : {} },
                    "europe": { years : {} },
                    "asian": { years : {} },
                    "americ": { years : {} }
                };
                var indicatorKeys = _.keys(yearsObjTotal);

                /*
                var tmpAreaChartSeries = [{
                    name: "Switzerland",
                    color: "#5BAB93",
                    data: _.map(this.offshoreFinancialCountryData.indicators["swiss"].years, function (yObj){ return yObj.value; })
                }]
                */

                var totalGDP = 0;

                _.each(this.filteredCountries, function (objCountry){
                    _.each(indicatorKeys, function (indicatorID, indicatorInc){
                        _.each(objCountry.allIndicators[indicatorID].years, function (yearObj, yearID){
                            if(yearsObjTotal[indicatorID].years[yearID] == undefined) {
                                yearsObjTotal[indicatorID].years[yearID] = { 
                                    value: 0, 
                                    totalGDP: 0, 
                                    totalWealth: 0,
                                    weightedAvgSum: 0
                                }
                            }
                            if(yearObj.value != null && yearObj.value != "nodata"){
                                yearsObjTotal[indicatorID].years[yearID].value += yearObj.value;

                                if(indicatorInc == 0){
                                    /*
                                    var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                        return String(o.year) == String(yearID) && o.iso3 == objCountry.countryCode;
                                    })
                                    */
                                    if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[objCountry.countryCode] != undefined){
                                        var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[objCountry.countryCode].years[yearID];
                                        if(denominatorObj["gdp_USD_billion"] != 'nodata') yearsObjTotal[indicatorID].years[yearID].totalGDP += denominatorObj["gdp_USD_billion"];
                                        if(denominatorObj["personal_wealth_USD_billion"] != 'nodata') yearsObjTotal[indicatorID].years[yearID].totalWealth += denominatorObj["personal_wealth_USD_billion"];
                                    }
                                } else {
                                    yearsObjTotal[indicatorID].years[yearID].totalGDP = yearsObjTotal[indicatorKeys[0]].years[yearID].totalGDP
                                    yearsObjTotal[indicatorID].years[yearID].totalWealth = yearsObjTotal[indicatorKeys[0]].years[yearID].totalWealth
                                }
                            }
                        })
                    })
                })

                if(this.selectedIndicator.id == "pctGDPFinancial" || this.selectedIndicator.id == "pctHouseholdWealth"){
                    _.each(this.filteredCountries, function (objCountry){
                        _.each(indicatorKeys, function (indicatorID, indicatorInc){
                            _.each(objCountry.allIndicators[indicatorID].years, function (yearObj, yearID){
                                if(yearObj.value != null && yearObj.value != "nodata"){
                                    /*
                                    var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                        return String(o.year) == String(yearID) && o.iso3 == objCountry.countryCode;
                                    })
                                    */
                                    if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[objCountry.countryCode] != undefined){
                                        var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[objCountry.countryCode].years[yearID];
                                        if(self.selectedIndicator.id == "pctGDPFinancial" && denominatorObj.gdp_USD_billion != 'nodata'){
                                            yearsObjTotal[indicatorID].years[yearID].weightedAvgSum += (yearObj.value * (denominatorObj.gdp_USD_billion / yearsObjTotal[indicatorID].years[yearID].totalGDP))
                                        } else if(self.selectedIndicator.id == "pctHouseholdWealth" && denominatorObj.personal_wealth_USD_billion != 'nodata'){
                                            yearsObjTotal[indicatorID].years[yearID].weightedAvgSum += (yearObj.value * (denominatorObj.personal_wealth_USD_billion / yearsObjTotal[indicatorID].years[yearID].totalWealth))
                                        }
                                    }
                                }
                            })
                        })
                    })
                    /*
                        _.each(countryObj.indicatorObj.years, function (yearObj, yearID){
                                if(yearObj.value != null && yearObj.value != 'nodata'){
                                    var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                        return String(o.year) == String(yearID) && o.iso3 == countryObj.countryCode;
                                    })
                                    if(denominatorObj.ndp_USD_billion != 'nodata'){
                                        yearlyObj[yearID].weightedAvgSum += (yearObj.value * (denominatorObj.ndp_USD_billion / yearlyObj[yearID].ndpTotal));
                                    }
                                }
                            })
                        });
                    */
                }

                var denominator = 1;

                var tmpAreaChartSeries = [
                    {
                        name: "Switzerland",
                        color: "#BAC6DF",
                        data: _.map(yearsObjTotal["swiss"].years, function (yObj){ 
                            if(self.selectedIndicator.id == "pctGDPFinancial") return (yObj.value/yObj.totalGDP) * 100; 
                            return yObj.value / denominator; })
                    },
                    {
                        name: "European tax havens",
                        color: "#204FAA",
                        data: _.map(yearsObjTotal["europe"].years, function (yObj){ 
                            if(self.selectedIndicator.id == "pctGDPFinancial") return (yObj.value/yObj.totalGDP) * 100; 
                            return yObj.value / denominator;
                        })
                    }, 
                    {
                        name: "Asian tax havens",
                        color: "#6180BC",
                        data: _.map(yearsObjTotal["asian"].years, function (yObj){
                            if(self.selectedIndicator.id == "pctGDPFinancial") return (yObj.value/yObj.totalGDP) * 100; 
                            return yObj.value / denominator;
                        })
                    }, 
                    {
                        name: "American tax havens",
                        color: "#29264C",
                        data: _.map(yearsObjTotal["americ"].years, function (yObj){
                            if(self.selectedIndicator.id == "pctGDPFinancial") return (yObj.value/yObj.totalGDP) * 100; 
                            return yObj.value / denominator;
                        })
                    }, 
                ];

                this.areaChartData = JSON.parse(JSON.stringify(tmpAreaChartSeries));
            },

            updateCountriesRankingAndMap: function (){
                var self = this;
                var tmpCountriesRankingData = [];
                var availableYears = {};

                _.each(this.filteredCountries, function (countryObj){
                    if(self.DBCountriesObj[countryObj.countryCode] != undefined){
                        var countryObjToAppend = {
                            countryCode: countryObj.countryCode,
                            countryLabel: self.DBCountriesObj[countryObj.countryCode].country_name
                        }
                        var hasOnlyNullValues = true;

                        if(self.datasetID == "global-profit"){
                            if(countryObj.indicatorObj.counterparts[self.selectedCounterpart.id] != undefined){
                                hasOnlyNullValues = false;
                                countryObjToAppend.years = countryObj.indicatorObj.counterparts[self.selectedCounterpart.id].years
                            }
                        } else if(self.datasetID == "offshore-real-estate"){
                            var yearsObj = countryObj.indicatorObj.years;
                            var yearsTotalsObj = {};

                            _.each(yearsObj, function (yearObj, yearID){
                                var totalYear = 0;
                                _.each(yearObj, function (cityObj, cityID){
                                    if(cityObj.value != 0 && cityObj.value != null && cityObj.value != 'nodata'){
                                        hasOnlyNullValues = false;
                                        totalYear += cityObj.value;
                                    }
                                })
                                yearsTotalsObj[yearID] = { value: totalYear };
                            })
                            countryObjToAppend.years = yearsTotalsObj;
                        } else if(self.datasetID == "offshore-financial" || self.datasetID == "effective-tax"){
                            hasOnlyNullValues = false;
                            countryObjToAppend.years = countryObj.indicatorObj.years;
                        }

                        if(!hasOnlyNullValues){
                            tmpCountriesRankingData.push(countryObjToAppend)
                            _.each(countryObjToAppend.years, function (yearObj, yearID){
                                if(availableYears[yearID] == undefined) availableYears[yearID] = { yearID: yearID, total: 0 };
                                if(yearObj.value != null && yearObj.value != 'nodata'){
                                    availableYears[yearID].total += 1;
                                }
                            })
                        }
                    }
                })

                var noDataYears = _.filter(availableYears, function (o){ return o.total == 0; });
                if(noDataYears.length > 0){
                     _.each(tmpCountriesRankingData, function (countryObj){
                        _.each(noDataYears, function (yearObj){
                            delete countryObj.years[yearObj.yearID];
                        })
                    })
                }

                this.countriesRankingData = JSON.parse(JSON.stringify(tmpCountriesRankingData));

                if(this.countriesRankingData.length > 0){
                    this.rankingHasData = true;
                    this.mapHasData = true;
                } else {
                    this.rankingHasData = false;
                    this.mapHasData = false;
                }

                this.updateMapData();
            },

            updateMapData: function (){
                var tmpMapData = {
                    countries: JSON.parse(JSON.stringify(this.countriesRankingData)),
                    type: (!this.selectedTaxHavens) ? "map" : "bubbles"
                }

                if(this.hasTaxHavensData && !this.selectedTaxHavens){
                    _.each(this.taxHavensCountries, function (o){
                        tmpMapData.countries.push({
                            countryCode: o.iso3,
                            countryLabel: o.country_name,
                            isTaxHaven: true
                        })
                    })
                }

                this.countriesMapData = JSON.parse(JSON.stringify(tmpMapData));
            },

            updateRealEstate2Barchart: function (){
                var sortedCities = _.sortBy(this.DBRealEstate2, function (o){
                    return -parseFloat(o.value);
                })

                var tmpSeries = [{
                    name: "Cities",
                    color: "#F18321",
                    data: _.map(sortedCities, function (o){ return parseFloat(o.value); })
                }];

                var tmpCategories = _.map(sortedCities, function (o){
                    return o.city;
                });

                this.realEstate2Series = JSON.parse(JSON.stringify(tmpSeries));
                this.realEstate2Categories = JSON.parse(JSON.stringify(tmpCategories));
            },

            openMobileFilters: function (){
                this.$refs.appHeaderRef.mobileMenuDisplayed = !this.$refs.appHeaderRef.mobileMenuDisplayed;
            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },

            truncate(text) {
                if(text.length > this.mapMoreTextLimit) return `${text.substring(0, this.mapMoreTextLimit)}...`;
                return text;
            },

            truncateSelectboxItem(text) {
                if(text.length > this.selectboxItemLimit) return `${text.substring(0, this.selectboxItemLimit)}...`;
                return text;
            },

            toggleTaxHavens: function (){
                var self = this;
                this.selectedTaxHavens = !this.selectedTaxHavens
                this.togglerFreezed = true;
                this.$refs.appMapRef.currentYear = null;
                this.updatePage();
                setTimeout(function (){
                    self.togglerFreezed = false;
                }, 2000)
            },

            forceShowMobileFilters: function (){
                this.stickyFiltersExpanded = !this.stickyFiltersExpanded;
                if(this.stickyFiltersExpanded){
                    this.forceShowMobile = true;
                    var app = document.getElementById('app');
                    app.classList.add("sticky");
                } else {
                    this.forceShowMobile = false;
                }
            },

            toggleMobileFilters: function (){
                this.stickyFiltersExpanded = !this.stickyFiltersExpanded;
                this.forceShowMobile = false;
            },

            //export Barchart callback function
            exportGraphic: function (exportType, isMap) {
                var exportParams = {
                    title: this.datasetParams.label,
                    isMap: (isMap !== undefined && isMap)
                };
                UTILS.exportGTAB('Wrapper_' + exportType, exportParams);
            },

            //export XLS callback function
            exportXLS: function (exportType) {
                var self = this;

                var indicatorLabel = "";
                if(this.selectedIndicator.id != 'corp_tax_lost'){
                    if(this.selectedIndicator.subtitleLabel != undefined){
                        indicatorLabel += this.selectedIndicator.subtitleLabel
                    } else {
                        indicatorLabel += this.selectedIndicator.label
                    }

                    if(!this.selectedTaxHavens && this.datasetID =='global-profit') indicatorLabel += " lost";
                    else if(this.selectedTaxHavens && this.datasetID =='global-profit') indicatorLabel += " won";
                    else if(!this.selectedTaxHavens && this.datasetID =='offshore-financial') indicatorLabel += " held abroad";
                    else if(this.selectedTaxHavens && this.datasetID =='offshore-financial') indicatorLabel += " hosted";
                } else{
                    indicatorLabel = "Corporate tax revenue";
                    if(!this.selectedTaxHavens && this.datasetID =='global-profit') indicatorLabel += " lost";
                    else if(this.selectedTaxHavens && this.datasetID =='global-profit') indicatorLabel += " won";
                    else if(!this.selectedTaxHavens && this.datasetID =='offshore-financial') indicatorLabel += " held abroad";
                    else if(this.selectedTaxHavens && this.datasetID =='offshore-financial') indicatorLabel += " hosted";
                }

                var tableArray = [["Country", indicatorLabel + " (in " + this.indicatorUnit + ")"]];
                var exportDataArray = this.countriesRankingData;
                var exportDataYears = "";
                if(exportType == "timeseries"){
                    tableArray = [["Year", indicatorLabel + " (in " + this.indicatorUnit + ")"]];
                    exportDataArray = this.timeseriesData[0].data;
                    exportDataYears = this.timeseriesCategories;
                } else if(exportType == "barchart"){
                    tableArray = [["City", indicatorLabel + " (in " + this.indicatorUnit + ")"]];
                    exportDataArray = this.realEstate2Series[0].data;
                    exportDataYears = this.realEstate2Categories;
                } else if(exportType == "area"){
                    var regionsLabels = _.map(this.areaChartData, function (o){
                        return o.name;
                    })
                    regionsLabels.unshift("Year");
                    tableArray = [regionsLabels];

                    _.each(this.areaChartCategories, function (yearStr, incYear){
                        var incArray = _.map(self.areaChartData, function (o){
                            return UTILS.formatNumber(o.data[incYear],2, self.selectedIndicator.unit);
                        })
                        incArray.unshift(yearStr);
                        tableArray.push(incArray);
                    })
                }

                if(exportType != "area"){
                    _.each(exportDataArray, function (objData, index){
                        var objValue = "";
                        var objFirstCol = "";
                        if(exportType == "timeseries" || exportType == "barchart"){
                            objValue = UTILS.formatNumber(objData,2, self.selectedIndicator.unit);
                            objFirstCol = exportDataYears[index];
                        }
                        else if(exportType == "map"){
                            var mapYear = self.$refs.appMapRef.currentYear;
                            if(objData.years[mapYear] !== undefined && objData.years[mapYear].value != null) objValue = UTILS.formatNumber(objData.years[mapYear].value,2, self.selectedIndicator.unit);
                            else objValue = "no data";
                            objFirstCol = objData.countryLabel;
                        }

                        tableArray.push([objFirstCol, objValue]);
                    })
                }

                tableArray.push(['','','','','']);
                tableArray.push(['','','','','']);
                tableArray.push(['Filters','','','','']);

                if(this.hasTaxHavensData){
                    if(this.selectedTaxHavens) tableArray.push(['Tax havens']);
                    else tableArray.push(['Non Tax havens']);
                }

                tableArray.push(['Dataset', this.datasetParams.label,'','','']);
                tableArray.push(['Indicator', indicatorLabel,'','','']);

                if(this.datasetID == 'global-profit' && !this.selectedTaxHavens){
                    tableArray.push(['Counterpart', this.selectedCounterpart.label,'','','']);
                }                

                tableArray.push(['Region', this.selectedRegion.label,'','','']);
                tableArray.push(['Income Level', this.selectedIncomeLevel.label,'','','']);

                if(exportType == "map"){
                    tableArray.push(['Year', self.$refs.appMapRef.currentYear,'','','']);
                }
                

                tableArray.push(['','','','','']);
                tableArray.push(['','','','','']);
                tableArray.push(['Eu Tax Observatory Global Repository','','','','']);
                tableArray.push([location.href,'','','','']);
                tableArray.push(['Exported on',UTILS.getCurrentDate(),'','','']);

                generateXLS(tableArray);
            },

            callbackMapCurrentYear: function (payload){
                this.mapCurrentYear = payload;
            },

            handleMapCountryClicked: function (countryID, countryValue, countryColor){
                this.showMapModal = true;
                this.MapModalCountryID = countryID;
                this.countryTooltipData = {
                    id: countryID,
                    value: countryValue,
                    color: countryColor
                }

                this.mapModalCountryDBDataset = this.DBDatasets[this.datasetID][countryID];
                this.mapModalCountryDB = this.DBCountriesObj[countryID];
                console.log("mapModalCountryDBDataset", this.mapModalCountryDBDataset);
                console.log("mapModalCountryDB", this.mapModalCountryDB);
                console.log("handleMapCountryClicked", this.countryTooltipData);
            },

            handleCloseMapModal: function (){
                this.showMapModal = false;
            },

            expandMap: function (){
                var self = this;
                var outerSVG = document.querySelector(".world-map .svg_container").outerHTML;
                console.log("expandMap", outerSVG);
                document.querySelector("#MobileExpandedMap .map_container").innerHTML = outerSVG;
                
                setTimeout(function (){
                    var mapElement = document.querySelector('#MobileExpandedMap .map_container svg');
                    self.panMapinstance = panzoom(mapElement, {
                        initialX: -400,
                        initialZoom: 1,
                        onTouch: function(e) {
                            // `e` - is current touch event.
                            e.preventDefault();
                            /*
                            var elem = e.target;
                            var dataCountry = elem.getAttribute("data-country");
                            console.log("onTouch");
                            if(dataCountry != null){
                                var fillCountry = elem.getAttribute("fill");
                                self.delayMapMobileHandleMapCountryClicked(dataCountry, 0, fillCountry);
                                //self.handleMapCountryClicked(dataCountry, 0, fillCountry);
                            }
                            e.preventDefault();e.stopPropagation();
                            return false; // tells the library to not preventDefault.
                            */
                          }
                    });

                    self.panMapinstance.moveTo(-400, 0);

                    self.panMapinstance.on('panstart', function(e) {
                        console.log("panstart")
                      self.allowTouchExpandMapMobile = false;
                    });

                    self.panMapinstance.on('panend', function(e) {
                        console.log("panend")
                      setTimeout(function (){
                            self.allowTouchExpandMapMobile = true;
                        }, 300)
                    });

                    self.panMapinstance.on('zoom', function(e) {
                        self.allowTouchExpandMapMobile = false;
                        // Set a timeout to reset touchability after zoom ends
                        clearTimeout(self.zoomTimeout); // Clear any previous timeout
                        self.zoomTimeout = setTimeout(function() {
                            self.allowTouchExpandMapMobile = true;
                        }, 300); // Adjust the delay as needed
                    });

                    document.querySelector("#MobileExpandedMap").setAttribute("data-displayed", "true");
                }, 100)

                setTimeout(function (){
                    self.bindCountryMobileEvents();
                }, 500)
            },


            bindCountryMobileEvents: function (){
                var self = this;

                var countryPaths = document.querySelectorAll('#MobileExpandedMap .map_container svg path.country');
                _.each(countryPaths, function (pathElem){
                    pathElem.addEventListener('touchstart', function(event) {
                        //document.querySelector("#MapDebug").innerHTML += " tstart path drag=" + self.touchDragging + " ";
                        self.touchTimeout = setTimeout(function () {
                          self.touchDragging = true;
                        }, 1000);
                    });
                    pathElem.addEventListener('touchend', function(event) {
                        //document.querySelector("#MapDebug").innerHTML += " tend path drag=" + self.touchDragging + " ";

                        clearTimeout(self.touchTimeout);
                        if (self.touchDragging === true) {
                          setTimeout(function () {
                            self.touchDragging = false;
                          }, 1200);
                          return;
                        }

                        if(!self.allowTouchExpandMapMobile){
                            return;
                        }

                        var dataCountry = pathElem.getAttribute("data-country");
                        if(dataCountry != null){
                            var fillCountry = pathElem.getAttribute("fill");
                            self.delayMapMobileHandleMapCountryClicked(dataCountry, 0, fillCountry);
                            //self.handleMapCountryClicked(dataCountry, 0, fillCountry);
                        }
                    });
                })
            },

            delayMapMobileHandleMapCountryClicked: function(dataCountry, valueCountry, fillCountry){
                var self = this;
                setTimeout(function (){
                    console.log("allow display !!!", dataCountry, valueCountry, fillCountry);
                    self.handleMapCountryClicked(dataCountry, valueCountry, fillCountry);
                    self.displayMobileMapModal();
                }, 0)
            },

            closeExpandedMap: function(){
                document.querySelector("#MobileExpandedMap").setAttribute("data-displayed", "false");
                document.querySelector("#MobileExpandedMap .map_container").innerHTML = "";
                this.panMapinstance.dispose();
                this.showMapModal = false;
                document.querySelector("#MobileBottomFixed").innerHTML = "";
            },

            displayMobileMapModal: function (){
                var self = this;
                console.log("displayMobileMapModal");
                setTimeout(function (){
                    document.querySelector("#MobileBottomFixed").innerHTML = document.querySelector("#Wrapper_map #MapModal").outerHTML;

                    var myCloseBt = document.querySelector('#MobileBottomFixed .modal_closebt');

                    // Add a click event listener to the div
                    myCloseBt.addEventListener('click', function() {
                        document.querySelector("#MobileBottomFixed").innerHTML = "";
                        self.showMapModal = false;
                    });
                }, 300)
            }
        },

        watch: {
            selectedIndicator: function (){
                if(this.isDataLoaded){
                    this.updatePage();
                }
            },

            selectedRegion: function () {
                if(this.isDataLoaded){
                    this.updatePage();
                }
            },

            selectedIncomeLevel: function () {
                if(this.isDataLoaded){
                    this.updatePage();
                }
            },

            selectedCounterpart: function (){
                if(this.isDataLoaded){
                    this.updatePage();
                }
            }
        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #Dataset{
        .main .main_inner{
            padding-top: 40px;
        }
        &[data-taxhavens-selected="true"]{
            .ranking_wrapper .ranking_area .country_bar_container .container_inner .country_bar{
                background: $colorOrange;
            }
        }
        .main{
            .main_section{
                .section_content{
                    .page_infographic{
                        position: relative;
                        text-align: center;
                        width: 100%;
                        &[data-dataset="global-profit"]{
                            
                        }
                        &.expanded{
                            .infographic_image{
                                height: auto;
                            }
                        }
                        .infographic_image{
                            position: relative;
                            max-width: 696px;
                            width: 100%;
                            height: 320px;
                            display: inline-block;
                            vertical-align: top;
                            overflow: hidden;
                            box-shadow: 0px -20px 60px 0px rgba(22, 65, 147, 0.20);
                            .image_bg{
                                width: 100%;
                                height: auto;
                            }
                        }
                        .more_actionbar{
                            margin-top: -12px;
                            &:after{
                                content:"";
                                background: linear-gradient(180deg, rgba(238, 241, 246, 0.00) 0%, #EEF1F6 100%);
                                position: absolute;
                                left: 0px;
                                bottom: 13px;
                                width: 100%;
                                height: 50px;
                                z-index: 1;
                            }
                            .actionbar_bt{
                                z-index: 2;
                            }
                        }
                    }
                    .navigation_bt{
                        margin-top: 10px;
                    }
                    .row_filters{
                        margin-top: 10px;
                        position: relative;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #bac6df;
                        &#MobileFilters{
                            display: none;
                        }
                    }
                    .content_filter{
                        position: relative;
                        margin-right: 10px;
                        .app_selectbox{
                            width: 220px;
                        }
                    }
                    .content_col.col_ranking{
                        width: 580px;
                        margin-right: 20px;
                        margin-top: 20px;
                        .ranking_container{
                            position: relative;
                            &.notdisplayed{
                                display: none;
                            }
                        }
                    }
                    .content_col.col_ranking_text{
                        width: 328px;
                        margin-top: 20px;
                    }
                }
                &.section_bubbles{
                    padding: 60px 0 140px;
                    color: #fff;
                    position: relative;
                    background: #29264C;
                    &:before{
                        content: "";
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        height: 200px;
                        width: 100%;
                        background: linear-gradient(180deg, #164193 0%, #29264C 100%);
                    }
                    .bubble_container{
                        position: relative;
                        .text_p{
                            color: #fff;
                            margin-top: 20px;
                        }
                        &.notdisplayed{
                            display: none;
                        }
                    }
                    .section_content{
                        border-top: 4px solid #fff;
                        padding: 6px 0 0;
                        max-width: 928px;
                        position: relative;
                        z-index: 1;
                        .content_title{
                            color: #fff;
                            letter-spacing: 3.2px;
                            font-weight: 400;
                        }
                    }
                    .row_barchart{
                        padding-top: 20px;
                        //margin-top: 80px;
                        height: 600px;
                        //border-top: 4px solid  #164193;
                        .legend_title{
                            margin-bottom: 20px;
                            color: #fff;
                        }
                    }
                    .content_downloadbar{
                        margin: 40px 0 0;
                        background: #191637;
                        .downloadbar_title{
                            color: #fff;
                        }
                    }
                    .content_more{
                        padding: 0px;
                        .more_actionbar{
                            &:before{
                                background: #164193;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// pages/dataset/_datasetID.vue